import { Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-process-small-spinner',
    templateUrl: './process-small-spinner.component.html',
    styleUrls: ['./process-small-spinner.component.scss']
})
export class ProcessSmallSpinnerComponent {
    @Input()
    isVisible: boolean;
}
